<!-- <template lang="es">
    <v-container fluid>
        <v-expansion-panels accordion> 
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-card-title>
                        Tipos de Tratamiento 
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <CrudTiposMantenimiento/>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="getIsAdmin">
                <v-expansion-panel-header>
                    <v-card-title>
                        Gestión de Usuarios 
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <GestionUsuarios></GestionUsuarios>
                </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
    </v-container>
</template> -->
<template lang="es">
    <v-container fluid>
        <v-expansion-panels accordion> 
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-card-title>
                        Tipos de Tratamiento 
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <CrudTiposMantenimiento/>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="getIsAdmin">
                <v-expansion-panel-header>
                    <v-card-title>
                        Gestión de Usuarios 
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <GestionUsuarios/>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-card-title>
                        Gestión de Emails
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <GestionEmails/>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="getIsAdmin">
                <v-expansion-panel-header>
                    <v-card-title>
                        Ajustes Generales
                    </v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <GestionAjustesGenerales/>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>
    </v-container>
</template>

<script>
import CrudTiposMantenimiento from "@/components/crud/CrudTiposMantenimiento.vue";
import GestionEmails from "@/components/GestionEmails.vue";
import GestionUsuarios from "@/components/GestionUsuarios.vue";
import GestionAjustesGenerales from "@/components/GestionAjustesGenerales.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CrudTiposMantenimiento,
    GestionUsuarios,
    GestionEmails,
    GestionAjustesGenerales
    // ComponenteCrud,FormularioTipoTratamiento
  },
  computed:{
    ...mapGetters(['getIsAdmin'])
  },
};
</script>
<style lang="">
</style>